import { FC } from 'react';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';

import InventoryPortal from './InventoryPortal';

const InventoryPortalClassWrapper: FC = () => {
  const [query, { updateSearchParams, navigate }] = useNavigation({
    id: SearchParamType.STRING,
    center: SearchParamType.STRING,
    zoom: SearchParamType.STRING,
  });
  return (
    // @ts-ignore
    <InventoryPortal
      updateSearchParams={updateSearchParams}
      navigate={navigate}
      query={query}
    />
  );
};

export default InventoryPortalClassWrapper;
